import { render, staticRenderFns } from "./Epicos.vue?vue&type=template&id=7fb29fd5&scoped=true"
import script from "./Epicos.vue?vue&type=script&lang=js"
export * from "./Epicos.vue?vue&type=script&lang=js"
import style0 from "./Epicos.vue?vue&type=style&index=0&id=7fb29fd5&prod&scoped=true&lang=css"
import style1 from "./Epicos.vue?vue&type=style&index=1&id=7fb29fd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb29fd5",
  null
  
)

export default component.exports